import { motion } from "framer-motion";
import { profileData } from "../data/profileData";
import { FiDownload, FiArrowRight } from "react-icons/fi";

const Hero = () => {
	const containerVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: {
				staggerChildren: 0.15,
				delayChildren: 0.2,
			},
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 20 },
		visible: {
			opacity: 1,
			y: 0,
			transition: { duration: 0.6 },
		},
	};

	const imageVariants = {
		hidden: { opacity: 0, x: 30 },
		visible: {
			opacity: 1,
			x: 0,
			transition: { duration: 0.8, delay: 0.3 },
		},
	};

	return (
		<section id="home" className="hero-section">
			<motion.div
				className="hero-copy"
				initial="hidden"
				animate="visible"
				variants={containerVariants}
			>
				<motion.p className="eyebrow" variants={itemVariants}>
					Hi, I'm
				</motion.p>
				<motion.h1 variants={itemVariants}>{profileData.name}</motion.h1>
				<motion.p className="hero-text" variants={itemVariants}>
					{profileData.headline}
				</motion.p>
				<motion.p className="hero-subtext" variants={itemVariants}>
					{profileData.heroSummary}
				</motion.p>
				<motion.div className="hero-actions" variants={itemVariants}>
					<a className="btn btn-primary" href={profileData.resume} download>
						<FiDownload /> Download Resume
					</a>
					<a className="btn btn-secondary" href="#contact">
						Contact Me <FiArrowRight />
					</a>
				</motion.div>
			</motion.div>
			<motion.div
				className="hero-image"
				initial="hidden"
				animate="visible"
				variants={imageVariants}
			>
				<div className="hero-card">
					<div className="hero-card-header">
						<div className="window-dots">
							<span className="dot dot-red"></span>
							<span className="dot dot-yellow"></span>
							<span className="dot dot-green"></span>
						</div>
						<div className="window-title">status.json</div>
					</div>
					<div className="hero-card-inner">
						<div className="hero-status-pill">
							<span className="pulse-dot"></span>
							<span className="status-label">Available for work</span>
						</div>
						<div className="hero-card-title">Current Focus</div>
						<p className="hero-card-copy">
							{profileData.role}
						</p>
						{/* <p className="hero-card-location">
							📍 {profileData.location}
						</p> */}
						<div className="hero-tags">
							{profileData.heroHighlights.map((item) => (
								<span key={item} className="hero-tag">
									{item}
								</span>
							))}
						</div>
					</div>
				</div>
			</motion.div>
		</section>
	);
};

export default Hero;
